// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BC-Page__AppImpact .total-metrics {
  display: flex;
  gap: 16px;
}

.BC-Page__AppImpact .total-metrics .item {
  width: calc((100% - 32px) / 5);
  padding: 8px 16px 16px;
  border-radius: 4px;
  background: #fafbfb;
}

.BC-Page__AppImpact .trend-overview > .Polaris-Card > .Polaris-Card__Header .Polaris-Heading,
.BC-Page__AppImpact .total-metrics .item .Polaris-TextStyle--variationStrong {
  border-bottom: 3px dotted #dfe3e8;
  display: inline-block;
}

.BC-Page__AppImpact .total-metrics .item .BC-chart__total {
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  margin-top: 8px;
}

.BC-Page__AppImpact .trend-overview > .Polaris-Card > .Polaris-Card__Header {
  padding: 16px 20px;
  border-bottom: 1px solid #e8e9eb;
}

.BC-Page__AppImpact .trend-overview .BC_VerticalTab_Wrapper .Polaris-Card__Header h2 {
  border-bottom: unset !important;
}
.BC-Page__AppImpact .trend-overview .Polaris-Card__Section {
  padding: unset;
}

.BC-Page__AppImpact .trend-overview .tab-items .tab-selected .tab-name {
  color: #008060;
  font-weight: 600;
}

.BC-Page__AppImpact .list-features {
  display: flex;
  justify-content: space-between;
  background: #fffbf3;
  border-radius: 8px;
  padding: 12px 20px;
  align-items: center;
}

.BC-Page__AppImpact .list-features .links {
  display: flex;
  gap: 20px;
  color: #2C6ECB;
  padding: 8px 0;
}

.BC-Page__AppImpact .list-features>p {
  display: flex;
  align-items: center;
  gap: 6px;
}

.BC-Page__AppImpact .list-features .links .Polaris-Icon {
  margin: unset;
}

.BC-Page__AppImpact .list-features .links .Polaris-Link {
  display: flex;
} 
`, "",{"version":3,"sources":["webpack://./src/styles/analytics.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;AACA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf","sourcesContent":[".BC-Page__AppImpact .total-metrics {\n  display: flex;\n  gap: 16px;\n}\n\n.BC-Page__AppImpact .total-metrics .item {\n  width: calc((100% - 32px) / 5);\n  padding: 8px 16px 16px;\n  border-radius: 4px;\n  background: #fafbfb;\n}\n\n.BC-Page__AppImpact .trend-overview > .Polaris-Card > .Polaris-Card__Header .Polaris-Heading,\n.BC-Page__AppImpact .total-metrics .item .Polaris-TextStyle--variationStrong {\n  border-bottom: 3px dotted #dfe3e8;\n  display: inline-block;\n}\n\n.BC-Page__AppImpact .total-metrics .item .BC-chart__total {\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 32px;\n  margin-top: 8px;\n}\n\n.BC-Page__AppImpact .trend-overview > .Polaris-Card > .Polaris-Card__Header {\n  padding: 16px 20px;\n  border-bottom: 1px solid #e8e9eb;\n}\n\n.BC-Page__AppImpact .trend-overview .BC_VerticalTab_Wrapper .Polaris-Card__Header h2 {\n  border-bottom: unset !important;\n}\n.BC-Page__AppImpact .trend-overview .Polaris-Card__Section {\n  padding: unset;\n}\n\n.BC-Page__AppImpact .trend-overview .tab-items .tab-selected .tab-name {\n  color: #008060;\n  font-weight: 600;\n}\n\n.BC-Page__AppImpact .list-features {\n  display: flex;\n  justify-content: space-between;\n  background: #fffbf3;\n  border-radius: 8px;\n  padding: 12px 20px;\n  align-items: center;\n}\n\n.BC-Page__AppImpact .list-features .links {\n  display: flex;\n  gap: 20px;\n  color: #2C6ECB;\n  padding: 8px 0;\n}\n\n.BC-Page__AppImpact .list-features>p {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.BC-Page__AppImpact .list-features .links .Polaris-Icon {\n  margin: unset;\n}\n\n.BC-Page__AppImpact .list-features .links .Polaris-Link {\n  display: flex;\n} \n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
